import { useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Page } from '@/components/Page'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { useAuth } from '@/auth/useAuth'
import { TwoFactorAuthCard } from '@/features/security/TwoFactorAuthCard'

export function SecurityPage() {
  const { user } = useAuth()
  const [searchParams] = useSearchParams()
  const isFirstTime = searchParams.get('firstTime') === '1'

  const backLink = useMemo(
    () =>
      isFirstTime ? (
        <Button asChild variant="ghost" size="sm">
          <Link to="/dashboard">Skip for now →</Link>
        </Button>
      ) : null,
    [isFirstTime],
  )

  if (!user) {
    return (
      <Page title="Security" description="Sign in to manage your two-factor authentication.">
        <Card>
          <CardContent className="py-10 text-center text-sm text-muted-foreground">
            Please <Link to="/login" className="text-primary underline">sign in</Link> to access security settings.
          </CardContent>
        </Card>
      </Page>
    )
  }

  return (
    <Page
      title="Security"
      description="Protect your account with an authenticator app."
      actions={backLink}
      width="wide"
    >
      {isFirstTime ? (
        <Alert variant="info">
          <AlertDescription>
            <p className="text-sm font-semibold">Welcome to Bokapsys! 🎉</p>
            <p className="mt-1 text-xs">
              Set up two-factor authentication now to protect your account, then continue to the dashboard.
            </p>
          </AlertDescription>
        </Alert>
      ) : null}

      <TwoFactorAuthCard isFirstTime={isFirstTime} />
    </Page>
  )
}
